export default "__VITE_ASSET__CSKs4$zz__"